import axios from "axios";

export default class BaseQuery {
    static getOrigin() {
        const currentUrl = new URL(window.location.href);

        const port = currentUrl.hostname === 'localhost' ? '18888' : currentUrl.port;
        const origin = currentUrl.protocol + '//' + currentUrl.hostname + (port ? ':' + port : '');

        return origin;
    }

    static queryGet(params, successCb, errCb) {
        axios.get(BaseQuery.getOrigin() + `/index.php`, { params })
            .then(res => {
                const data = typeof res.data === 'string' ? JSON.parse(res.data) : res.data;

                if (data.result === "OK") {
                    successCb(data);
                } else if (data.result === "FAIL") {
                    errCb(data.error);
                } else {
                    errCb('No data');
                }

            }).catch((error) => {
            errCb(error);
            console.error(error);
        });
    }

    static queryPost(params, successCb, errCb) {
        const formData = new URLSearchParams(params);
        axios.post(BaseQuery.getOrigin()+`/index.php`, formData, {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            }
        })
            .then(res => {
                const data = typeof res.data === 'string' ? JSON.parse(res.data) : res.data;

                if (data.result === "OK") {
                    successCb(data);
                } else {
                    errCb('No data');
                }

            }).catch((error) => {
            errCb(error);
            console.error(error);
        });
    }
}
